import {
  AlignSelfType,
  BorderType,
  HoverType,
  PaddingType,
} from 'common/types/styleTypes'
import {
  backgroundCss,
  borderCss,
  boxShadowCss,
  FontProps,
  fontCss,
  hoverCss,
  hoverTransformCss,
  hoverTransitionCss,
  lineHeightCss,
  mobileBackgroundCss,
  mobileBorderCss,
  mobileBoxShadowCss,
  mobileFontCss,
  mobileHoverCss,
  mobileHoverTransformCss,
  mobileHoverTransitionCss,
  mobileLineHeightCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

type LinkUiProps = {
  background?: string
  mobileBackground?: string
  color?: string
  mobileColor?: string
  padding?: Partial<PaddingType>
  mobilePadding?: Partial<PaddingType>
  width?: 'auto' | '100%'
  mobileWidth?: 'auto' | '100%'
  border?: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  alignSelf?: AlignSelfType
  mobileAlignSelf?: AlignSelfType
  boxShadow?: string
  mobileBoxShadow?: string
  lineHeight?: number
  mobileLineHeight?: number
  hover?: HoverType
  mobileHover?: HoverType
} & FontProps

const LinkUi = styled.a<LinkUiProps>`
  text-align: center;
  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
  width: ${p => p.width || 'auto'};
  align-self: ${p => p.alignSelf || 'center'};
  cursor: pointer;
  ${backgroundCss}
  ${paddingsCss}
  ${fontCss}
  ${borderCss}
  ${boxShadowCss}
  ${lineHeightCss}
  ${hoverCss}
  ${hoverTransformCss}
  ${hoverTransitionCss}

  ${p => p.theme.phone} {
    width: ${p => p.mobileWidth || '100%'};
    align-self: ${p => p.mobileAlignSelf || 'center'};
    ${mobileBackgroundCss}
    ${mobilePaddingsCss}
    ${mobileFontCss}
    ${mobileBorderCss}
    ${mobileBoxShadowCss}
    ${mobileLineHeightCss}
    ${mobileHoverCss}
    ${mobileHoverTransformCss}
    ${mobileHoverTransitionCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileHoverCss}
      ${mobileHoverTransformCss}
      ${mobileHoverTransitionCss}
      ${mobileBackgroundCss}
      ${mobilePaddingsCss}
      ${mobileBorderCss}
      ${mobileFontCss}
      ${mobileBoxShadowCss}
      ${mobileLineHeightCss}
      width: ${p.mobileWidth || '100%'};
      align-self: ${p.mobileAlignSelf || 'center'};
    `}
`

export default LinkUi
